import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormNoticeOfIntent } from "../Models/Forms/IFormNoticeOfIntent";

@Injectable()
export class FormNoticeOfIntentService extends  BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormNoticeOfIntent(id: number) {
    return this._http.get(this._baseUrl + "api/FormNoticeOfIntent/" + id)
      .map((response: IFormNoticeOfIntent) => response as IFormNoticeOfIntent)
      .catch(this.errorHandler);
  }

  insertUpdateFormNoticeOfIntent(formNoticeOfIntentDetails: IFormNoticeOfIntent) {
    return this._http.post(this._baseUrl + 'api/FormNoticeOfIntent', formNoticeOfIntentDetails)
      .map((response: IFormNoticeOfIntent) => response as IFormNoticeOfIntent)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormNoticeOfIntent/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteNoticeOfIntent(id) {
    return this._http.delete(this._baseUrl + "api/FormNoticeOfIntent" + id)
      .map((response: IFormNoticeOfIntent) => response as IFormNoticeOfIntent)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}
